import doubleClickZoom from '../../../libraries/mapbox-gl-draw/src/lib/double_click_zoom';
import dragPan from './dragPan';
import { dragVertex, moveFeature } from './rectangle';
import createSupplementaryPoints from '../../../libraries/mapbox-gl-draw/src/lib/create_supplementary_points';
import MapboxGlDraw from '../../../libraries/mapbox-gl-draw/index.js';

var mapboxDraw = new MapboxGlDraw();

export default {
  ...mapboxDraw.options.modes.draw_polygon,
  // When the mode starts this function will be called.
  onSetup: function () {
    const rectangle = this.newFeature({
      type: "Feature",
      properties: { isRectangle: true, dragVertex, createSupplementaryPoints, moveFeature, },
      geometry: {
        type: "Polygon",
        coordinates: [[]],
      }
    });
    this.addFeature(rectangle);
    this.clearSelectedFeatures();
    doubleClickZoom.disable(this);
    dragPan.disable(this);
    this.updateUIClasses({ mouse: "add" });
    this.setActionableState({ trash: true });
    return { rectangle };
  },
  // support mobile taps
  onTap: function (state, e) {
    // emulate 'move mouse' to update feature coords
    if (state.startPoint) this.onMouseMove(state, e);
    // emulate onClick
    mapboxDraw.options.modes.draw_polygon.onClick.call(this, state, e);
  },
  onClick: function () { },
  onMouseDown: function (state, e) {
    state.startPoint = [e.lngLat.lng, e.lngLat.lat];
  },
  onDrag: function (state, e) {
    if (state.startPoint) {
      state.rectangle.updateCoordinate("0.0", state.startPoint[0], state.startPoint[1]); //minX, minY - the starting point
      state.rectangle.updateCoordinate("0.1", e.lngLat.lng, state.startPoint[1]); // maxX, minY
      state.rectangle.updateCoordinate("0.2", e.lngLat.lng, e.lngLat.lat); // maxX, maxY
      state.rectangle.updateCoordinate("0.3", state.startPoint[0], e.lngLat.lat); // minX,maxY
    }
  },
  onMouseUp: function (state, e) {
    this.updateUIClasses({ mouse: "pointer" });
    state.endPoint = [e.lngLat.lng, e.lngLat.lat];
    this.changeMode("simple_select", { featuresId: state.rectangle.id });
  },
  onMouseMove: function () { },
  // Whenever a user clicks on a key while focused on the map, it will be sent here
  onKeyUp: function (state, e) {
    if (e.keyCode === 27) return this.changeMode("simple_select");
  },
  onStop: function (state) {
    doubleClickZoom.enable(this);
    this.updateUIClasses({ mouse: "none" });
    this.activateUIButton();

    // check to see if we've deleted this feature
    if (this.getFeature(state.rectangle.id) === undefined) return;

    //remove last added coordinate
    state.rectangle.removeCoordinate("0.4");
    if (state.rectangle.isValid()) {
      this.map.fire("draw.create", { features: [state.rectangle.toGeoJSON()] });
    } else {
      this.deleteFeature([state.rectangle.id], { silent: true });
      this.changeMode("simple_select", {}, { silent: true });
    }
  },
  toDisplayFeatures: function (state, geojson, display) {
    const isActivePolygon = geojson.properties.id === state.rectangle.id;
    geojson.properties.active = isActivePolygon ? "true" : "false";
    if (!isActivePolygon) return display(geojson);

    // Only render the rectangular polygon if it has the starting point
    if (!state.startPoint) return;
    return display(geojson);
  },
  onTrash: function (state) {
    this.deleteFeature([state.rectangle.id], { silent: true });
    this.changeMode("simple_select");
  }
};

